export const container = ({ theme: { dimensions } }) => ({
    margin: '0 auto',
    maxWidth: dimensions.containerWidth,
    padding: '0 30px',
});
